import React from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { WrappedComponentProps, injectIntl } from 'react-intl';

import { InputTextArea } from '../../../../panda';

import DeleteBtn from '../Base/DeleteBtn';
import SpaceConfigs from '../Base/SpaceConfigs';
import BackgroundConfigs from '../Base/BackgroundConfigs';
import FontConfigs from '../Base/FontConfigs';
import DuplicateBtn from '../Base/DuplicateBtn';

import { IDispatch } from '../../../../modules/stores';
import { ISpace } from '../../../../types/space';
import { ElementTypes } from '../../../../types/element';

type IConnectProps = ReturnType<typeof mapDispatch>;
interface IProps extends IConnectProps, WrappedComponentProps {
  space: ISpace<ElementTypes.StaticText>;
}

class EditFormStaticText extends React.PureComponent<IProps> {
  public render() {
    const {
      space,
      updateSpaceConfig,
      intl: { formatMessage },
    } = this.props;

    return (
      <>
        <SpaceConfigs space={space} />
        <InputTextArea
          id="static-text-input"
          isSmall
          isReverse
          input={{
            value: get(space, 'config.content', ''),
            name: 'content',
            onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
              e.preventDefault();
              updateSpaceConfig({
                id: space.id,
                updates: { content: e.target.value },
              });
            },
          }}
          meta={{}}
          title={formatMessage({ id: 'sidebar.content' })}
        />
        <FontConfigs space={space} />
        <BackgroundConfigs space={space} />
        <DuplicateBtn spaceId={space.id} />
        <DeleteBtn />
      </>
    );
  }
}

const mapDispatch = ({ space }: IDispatch) => ({
  updateSpaceConfig: (payload: any) => space.updateSpaceConfig(payload),
});

export default compose(
  injectIntl,
  connect(
    () => ({}),
    // @ts-ignore
    mapDispatch,
  ),
)(EditFormStaticText);
